module.exports = __webpack_public_path__ + "6c4a0dbc/img/document.e2130c6b.svg";